import React, { useEffect, useState, forwardRef, useRef } from "react";
import { useTranslation } from "react-i18next";
import HttpService from "../../../services/HttpService";
import "../../../css/Pages.css"

const FlaggedState = forwardRef(({ interfaceId }, ref) => {
    const { t } = useTranslation();
    const [flaggedState, setFlaggedState] = useState(null);
    const flaggedUntilDate = flaggedState?.flaggedUntil ? new Date(flaggedState.flaggedUntil) : null;
    const flagged = Boolean(flaggedUntilDate && flaggedUntilDate.getTime() > Date.now());
    const [loading, setLoading] = useState(true);
    const axiosRef = useRef(null);

    const formatDateTime = (dateValue) => {
        if (!dateValue) return "-";

        const parsed = new Date(dateValue);
        if (Number.isNaN(parsed.getTime())) return dateValue;

        return parsed.toLocaleString();
    };

    useEffect(() => {
        if (!interfaceId) {
            setLoading(false);
            return;
        }

        const fetchFlaggedState = async (axiosClient) => {
            try {
                let url = process.env.REACT_APP_API_URL + "/Interfaces/flagged/" + interfaceId;
                const response = await axiosClient.get(url);
                setFlaggedState(response.data);
            } catch (err) {
                console.error("Failed to fetch flagged state", err);
            } finally {
                setLoading(false);
            }
        };

        const httpService = HttpService;
        httpService.configure();
        let axiosClient = httpService.getAxiosClient();
        axiosRef.current = axiosClient;

        fetchFlaggedState(axiosClient);
    }, [interfaceId]);

    const ResetFlaggedState = async () => {

        let url = process.env.REACT_APP_API_URL + "/Interfaces/flagged";
        let body = { interfaceId: interfaceId };
        axiosRef.current.put(url, body)
            .then((response) => {
                setFlaggedState(null);
            })
            .catch((err) => {
                console.error("Failed to reset flagged state", err);
            })
    };

    if (loading) return <div>{t("interface.flaggedStateLoading")}</div>;

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginTop: "0.5rem" }}>
            {flagged ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <span style={{ color: "red" }}>{t("interface.flaggedState")}</span>
                        <button onClick={ResetFlaggedState} className="btn btn-error">
                            {t("interface.resetFlaggedState")}
                        </button>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "max-content 1fr", columnGap: "0.75rem", rowGap: "0.25rem" }}>
                        <span>{t("interface.flaggedStateInterfaceId")}:</span>
                        <span>{flaggedState?.interfaceId ?? "-"}</span>

                        <span>{t("interface.flaggedStateSlowedMessageCount")}:</span>
                        <span>{flaggedState?.slowedMessageCount ?? "-"}</span>

                        <span>{t("interface.flaggedStateFlaggedAt")}:</span>
                        <span>{formatDateTime(flaggedState?.flaggedAt)}</span>

                        <span>{t("interface.flaggedStateFlaggedUntil")}:</span>
                        <span>{formatDateTime(flaggedState?.flaggedUntil)}</span>

                        <span>{t("interface.flaggedStateLastSlowedMessageAt")}:</span>
                        <span>{formatDateTime(flaggedState?.lastSlowedMessageAt)}</span>
                    </div>
                </div>
            ) : <div style={{ color: "green" }}>{t("interface.notFlaggedState")}</div>}
        </div>
    );
});

export default FlaggedState;
